import { Link } from "react-router-dom";
import { BadgeCheck, Sparkles } from "lucide-react";
import { useGang } from "@/lib/useGang";
import { bestGangTier, cartGangLines, honorsGang, lineSavings } from "@/lib/gang";

const money = (n) => `$${(n || 0).toFixed(2)}`;

function GangLine({ lines, testid, className = "" }) {
    const { tiers, member } = useGang();
    const total = lines.reduce((s, l) => s + (l.amount || 0), 0);
    if (total <= 0) return null;

    if (member) {
        const saved = lineSavings(member, lines);
        if (saved < 0.01) return null;
        return (
            <p className={`inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.14em] text-brand-green ${className}`}
                data-testid={`${testid}-member`}>
                <BadgeCheck size={12} /> You're saving {money(saved)} as a {member.name} member
            </p>
        );
    }

    const best = bestGangTier(tiers, lines);
    if (!best || best.saved < 0.5) return null;
    return (
        <Link to="/wholesale"
            className={`inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.14em] text-zinc-400 underline decoration-brand-green/40 underline-offset-4 transition-colors hover:text-brand-green ${className}`}
            data-testid={`${testid}-upsell`}>
            <Sparkles size={12} className="text-brand-green" />
            You'd save {money(best.saved)} with a {best.tier.name} Wholesale pass →
        </Link>
    );
}

/** One product / one designer total. */
export function GangSavings({ amount = 0, dtf = false, store, className = "", testid = "gang-savings" }) {
    if (!amount || amount <= 0) return null;
    if (!honorsGang(store)) {
        return (
            <p className={`font-mono text-[11px] uppercase tracking-[0.14em] text-zinc-500 ${className}`} data-testid="gang-not-honored">
                {store?.name || "This shop"} sets its own prices — Gang discounts don't apply here
            </p>
        );
    }
    return <GangLine lines={[{ amount, dtf }]} testid={testid} className={className} />;
}

/** Whole cart, skipping stores that don't honor the perks. */
export function GangCartSavings({ items = [], className = "", testid = "gang-cart" }) {
    return <GangLine lines={cartGangLines(items)} testid={testid} className={className} />;
}
